import { render, staticRenderFns } from "./RFQSavedItems.vue?vue&type=template&id=10146468&scoped=true"
import script from "./RFQSavedItems.vue?vue&type=script&lang=js"
export * from "./RFQSavedItems.vue?vue&type=script&lang=js"
import style0 from "./RFQSavedItems.vue?vue&type=style&index=0&id=10146468&prod&scoped=true&lang=css"
import style1 from "./RFQSavedItems.vue?vue&type=style&index=1&id=10146468&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10146468",
  null
  
)

export default component.exports